module.exports = __webpack_public_path__ + "fonts/OpenSans-Italic.c7dcce0.ttf";